

import React, { useState } from 'react';
import './HongButton.scss';
// React Icons for common button types
import { FaSync, FaPlus, FaEdit, FaTrash, FaSave, FaEye, FaSearch, FaDownload, 
  FaUpload, FaCopy, FaPen, FaArrowLeft, FaArrowRight, FaSignInAlt, FaUserPlus, 
  FaBan, FaChevronLeft, FaChevronRight, FaFileAlt, 
  FaChartBar, FaSpinner, FaPaperPlane, FaCheck, FaCheckCircle } from 'react-icons/fa';

const HongButton = ({
  children,
  onClick,
  className = '',
  disableTime = 0,
  startIcon,
  disabled = false, // 외부에서 전달된 disabled prop
  faIcon = null, // FontAwesome 아이콘 클래스 (예: 'fa-home', 'fas fa-user')
  reactIcon = null, // React Icon 컴포넌트 (예: <FaHome />)
  iconType = null, // 기본 제공 아이콘 타입: 'refresh', 'insert', 'update', 'delete', 'save', 'view', 'search', 'download', 'upload', 'copy', 'write', 'left', 'right', 'left2', 'right2', 'login', 'signup', 'cancel', 'report', 'chart', 'submit'
  iconPosition = 'left', // 아이콘 위치: 'left' 또는 'right'
  iconGap = '5px', // 아이콘과 텍스트 사이 간격 (픽셀 단위, 기본값: 5px)
  // 📷 다운로드 기능 관련 props
  isDownloading = false, // 다운로드 중인지 여부
  downloadText = '다운로드', // 다운로드 버튼 텍스트
  downloadingText = '다운로드 중...', // 다운로드 중 텍스트
  downloadReactIcon = <FaDownload />, // 다운로드 React Icon 기본값
  downloadingReactIcon = <FaSpinner className="fa-spin" />, // 다운로드 중 React Icon 기본값
  enableDownloadFeature = false, // 다운로드 기능 활성화 여부
  ...rest
}) => {
  const [ripples, setRipples] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [timer, setTimer] = useState(0);

  const createRipple = (event) => {
    const button = event.currentTarget;
    const rippleContainer = button.getBoundingClientRect();
    const size = Math.max(rippleContainer.width, rippleContainer.height);
    const x = event.clientX - rippleContainer.left - size / 2;
    const y = event.clientY - rippleContainer.top - size / 2;

    const newRipple = {
      key: new Date().getTime(),
      style: {
        width: size,
        height: size,
        top: y,
        left: x,
      },
    };

    setRipples((prevRipples) => [...prevRipples, newRipple]);

    setTimeout(() => {
      setRipples((prevRipples) =>
        prevRipples.filter((ripple) => ripple.key !== newRipple.key)
      );
    }, 600);
  };

  const handleMouseDown = (e) => {
    if (disabled || isDisabled) return;

    createRipple(e);

    if (onClick) {
      onClick(e);
    }

    if (disableTime > 0) {
      setIsDisabled(true);
      setTimer(disableTime);

      const countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(countdown);
            setIsDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  // 기본 제공 아이콘 매핑
  const getIconByType = (type) => {
    const iconMap = {
      'refresh': <FaSync />,
      'insert': <FaPlus />,
      'update': <FaEdit />,
      'delete': <FaTrash />,
      'save': <FaSave />,
      'view': <FaEye />,
      'search': <FaSearch />,
      'download': <FaDownload />,
      'upload': <FaUpload />,
      'copy': <FaCopy />,
      'write': <FaPen />,
      'left': <FaArrowLeft />,
      'right': <FaArrowRight />,
      'left2': <FaChevronLeft />,
      'right2': <FaChevronRight />,
      'login': <FaSignInAlt />,
      'signup': <FaUserPlus />,
      'cancel': <FaBan />,
      'report': <FaFileAlt />,
      'chart': <FaChartBar />,
      'submit': <FaPaperPlane />,
      'confirm': <FaCheck />,
      'select': <FaCheckCircle />,
      'list': <FaFileAlt />,
    };
    return iconMap[type] || null;
  };

  // 📷 다운로드 기능이 활성화된 경우 동적 React Icon/텍스트 설정
  const dynamicReactIcon = enableDownloadFeature 
    ? (isDownloading ? downloadingReactIcon : downloadReactIcon)
    : reactIcon;
  
  const dynamicChildren = enableDownloadFeature 
    ? (isDownloading ? downloadingText : (children || downloadText))
    : children;

  // 최종 아이콘 결정 (우선순위: dynamicReactIcon > iconType > faIcon)
  const finalIcon = dynamicReactIcon || getIconByType(iconType) || null;

  // 아이콘 스타일 생성
  const hasIcon = faIcon || finalIcon;
  const iconStyle = hasIcon ? {
    '--icon-gap': `${iconGap}`
  } : {};

  // 📷 다운로드 기능이 활성화된 경우 disabled 상태 동적 설정
  const finalDisabled = enableDownloadFeature 
    ? (disabled || isDisabled || isDownloading)
    : (disabled || isDisabled);

  return (
    <button
      className={`hong-button ${className} ${finalDisabled ? 'disabled' : ''} ${hasIcon ? 'has-icon' : ''} ${enableDownloadFeature ? 'download-button' : ''}`}
      style={iconStyle}
      // onMouseDown={handleMouseDown}
      onClick={handleMouseDown}//2번 적용돼서 수정함
      disabled={finalDisabled}
      {...rest}
    >
      {ripples.map((ripple) => (
        <span key={ripple.key} className="ripple" style={ripple.style} />
      ))}
      {isDisabled && disableTime > 0 ? (
        `다시시도 (${timer})`
      ) : (
        <>
          {startIcon && <span className="start-icon">{startIcon}</span>}
          {faIcon && iconPosition === 'left' && <i className={`${faIcon} button-icon icon-left`}></i>}
          {finalIcon && iconPosition === 'left' && <span className="button-icon icon-left">{finalIcon}</span>}
          <span className="button-text">{dynamicChildren}</span>
          {faIcon && iconPosition === 'right' && <i className={`${faIcon} button-icon icon-right`}></i>}
          {finalIcon && iconPosition === 'right' && <span className="button-icon icon-right">{finalIcon}</span>}
        </>
      )}
    </button>
  );
};


export default HongButton;

//2025-05-16 disable 추가